import React from 'react';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {
    Button,
    DialogActions,
    DialogTitle,
    InputLabel,
    Tab,
    Tabs,
    TextField,
    withStyles,
    DialogContent,
} from 'material-ui';
import {styles} from '../../style/staff_section';
import SimpleEditor from '../../../../components/editor/simple_editor';
import {TabContainer} from '../../../../components/tab/tab_container';
import SortableImageList from '../sortable_image_list';
import DropzoneImageField from '../../../../components/fields/field_dropzone_image';

class PartnersSectionEdit extends React.Component {
    state = {
        valueTab: 0,
    };

    onImageClick = (image, index) => {};

    handleTabChange = (event, value) => {
        this.setState({
            valueTab: value,
        });
    };

    render() {
        let {
            images,
            onDeleteImageField,
            onUpdateImagesField,
            onUpdateImagesSortOrder,
        } = this.props;
        let {classes, onHandleSubmit, onHandleClose} = this.props;
        let {title, body, onUpdateTitleField, onUpdateBodyField} = this.props;

        images = images || [];

        const {valueTab} = this.state;

        let notDeletedImages = images.filter(
            (image) => image.deleted === false
        );

        return (
            <EditDialog
                open={this.props.open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Partners Section</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />

                    <InputLabel className="simpleEditorLabelPages">
                        Body
                    </InputLabel>

                    <SimpleEditor
                        initialValue={body}
                        onChange={(htmlBody) => {
                            onUpdateBodyField(htmlBody);
                        }}
                    />

                    <Tabs
                        value={valueTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                    >
                        <Tab value={0} label="Upload Images" />
                        {notDeletedImages.length > 1 && (
                            <Tab value={1} label="Change Images Order" />
                        )}
                    </Tabs>

                    {valueTab === 0 && (
                        <TabContainer>
                            <DropzoneImageField
                                multiple={true}
                                images={images}
                                onImageDelete={(image, index) => {
                                    onDeleteImageField(image, index);
                                }}
                                onImageClick={this.onImageClick.bind(this)}
                                onImagesDrop={(images) => {
                                    onUpdateImagesField(images);
                                }}
                            />
                        </TabContainer>
                    )}
                    {valueTab === 1 && (
                        <TabContainer>
                            <SortableImageList
                                items={notDeletedImages}
                                onImagesSortOrder={(images) => {
                                    onUpdateImagesSortOrder(images);
                                }}
                            />
                        </TabContainer>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleClose(ev)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleSubmit(ev)}
                        color="primary"
                    >
                        Done
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(PartnersSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/partners_section_edit.js